var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6C5.45 6 4.97917 5.80417 4.5875 5.4125C4.19583 5.02083 4 4.55 4 4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2C6.55 2 7.02083 2.19583 7.4125 2.5875C7.80417 2.97917 8 3.45 8 4C8 4.55 7.80417 5.02083 7.4125 5.4125C7.02083 5.80417 6.55 6 6 6ZM2 10V8.6C2 8.31667 2.07292 8.05625 2.21875 7.81875C2.36458 7.58125 2.55833 7.4 2.8 7.275C3.31667 7.01667 3.84167 6.82292 4.375 6.69375C4.90833 6.56458 5.45 6.5 6 6.5C6.55 6.5 7.09167 6.56458 7.625 6.69375C8.15833 6.82292 8.68333 7.01667 9.2 7.275C9.44167 7.4 9.63542 7.58125 9.78125 7.81875C9.92708 8.05625 10 8.31667 10 8.6V10H2ZM3 9H9V8.6C9 8.50833 8.97708 8.425 8.93125 8.35C8.88542 8.275 8.825 8.21667 8.75 8.175C8.3 7.95 7.84583 7.78125 7.3875 7.66875C6.92917 7.55625 6.46667 7.5 6 7.5C5.53333 7.5 5.07083 7.55625 4.6125 7.66875C4.15417 7.78125 3.7 7.95 3.25 8.175C3.175 8.21667 3.11458 8.275 3.06875 8.35C3.02292 8.425 3 8.50833 3 8.6V9ZM6 5C6.275 5 6.51042 4.90208 6.70625 4.70625C6.90208 4.51042 7 4.275 7 4C7 3.725 6.90208 3.48958 6.70625 3.29375C6.51042 3.09792 6.275 3 6 3C5.725 3 5.48958 3.09792 5.29375 3.29375C5.09792 3.48958 5 3.725 5 4C5 4.275 5.09792 4.51042 5.29375 4.70625C5.48958 4.90208 5.725 5 6 5Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson24Px);
export default __webpack_public_path__ + "static/media/person_24px.d783a91d17e923b907f26f998b959096.svg";
export { ForwardRef as ReactComponent };